import React from "react";

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <img
              src="/img/logos/logos.svg"
              className="footer-img mx-auto d-block img-fluid"
              alt="Programa Raíz, Secretaría de Extensión, Universidad Nacional de Córdoba"
            />
          </div>
        </div>
      </div>

      <div className="footer-disclamer">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <small>
                Desarrollado por el Programa Raíz de Apoyo a la Gestión Local -
                UNC- SEU
              </small>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
